import axios from 'axios';
import { TurmaApiResponse } from '../service.types';
import { ConsultaListaTurmasAtuaisServiceProps, Service } from './consulta-lista-turmas-atuais.types';

export const consultaListaTurmasAtuaisService: Service<ConsultaListaTurmasAtuaisServiceProps> = async ({
  urlBase,
  token,
}) => {
  const path = `${urlBase}/turmas/status?status=ATUAL`;
  const authorization = `Bearer ${token}`;

  const { data } = await axios.get<TurmaApiResponse[]>(path, { headers: { authorization } });

  return data;
};
